import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/authContext";
import { useChat } from "../../../context/chatContext";
import createAxiosInstance from "../../../utils/axiosConfig";
import { useCases } from "../../../utils/constants";
import { nist_frameworks } from "../../../utils/endpoints";
import { FrameworkCategory } from "../../../utils/interfaces";
import ChatHeader from "../../common/chat/chatHeader";
import ChatHistory from "../../common/chatHistory";
import Footer from "../../common/footer";
import MaturityAssessment from "../../common/maturityAssessment";
import Sidebar from "../../common/sidebar";


const MaturityAssessmentBody = () => {
	const [frameworks, setFrameworks] = useState<FrameworkCategory[]>([]);
	const [isSelecting, setIsSelecting] = useState(false);
	const navigate = useNavigate();
	const { resetChatState, setSelectedUseCase } = useChat();
	const { logout } = useAuth();

	const fetchFrameworks = async () => {
		try {
			const response = await createAxiosInstance().get(nist_frameworks);
			if (response.status == 401 || response.status == 403) {
				// 401 is for expired token
				// 403 is for forbidden access (blocked by GPT.)
				console.log("use token expired");
				logout();
				return;
			}
			setFrameworks(response?.data);
		} catch (error: any) {
			console.error("Error fetching maturity assessment frameworks:", error);
		}
	};

	const handleSelect = async (index: number) => {
		if (isSelecting) return;
		resetChatState();
		// Set the selected use case
		setSelectedUseCase(index);
		setIsSelecting(true);
		if (index === useCases[0].value) {
			navigate(useCases[0].route);
		} else if (index === useCases[1].value) {
			navigate(useCases[1].route);
		} else if (index === useCases[2].value) {
			navigate(useCases[2].route);
		} else if (index === useCases[3].value) {
			navigate(useCases[3].route);
		}
		setIsSelecting(false);
	};


	useEffect(() => {
		fetchFrameworks();
	}, []);

	return (
		<div className="mainScreen min-vh-100">
			<Sidebar /> 
			
			<div className="main-content">
				<ChatHeader
					useCase={useCases[useCases.length - 1].value}
					selectUseCase={handleSelect}
				/>
				<MaturityAssessment frameworks={frameworks} onFrameworksChange={fetchFrameworks} />
				<Footer />
			</div>
			<ChatHistory
				onNavigate={(path: string) => {
					navigate(path);
				}}
			/>

		</div>
	);
};

export default MaturityAssessmentBody;
